module.exports = __webpack_public_path__ + "img/logo.56830fb1.png";